// extracted by mini-css-extract-plugin
module.exports = {"VersionCurrent":"LibsView_VersionCurrent__v8kWg","Panel":"LibsView_Panel__1XXge"};